import { oneOf, shape, string } from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import FnrTypography, { fnrTypographyPropTypes } from "UI/FnrTypography";

import FnrStaggeredEntry from "UI/FnrStaggeredEntry";

import FnrPageHeaderIcon, {
  fnrPageHeaderIconPropTypes,
} from "./FnrPageHeaderIcon";
import { headerVariants } from "./headerVariants";

export default function FnrPageHeader({
  title,
  icon,
  iconProps,
  titleProps,
  dataCy,
  variant,
  subtext,
}) {
  return (
    <FnrStaggeredEntry show variant="gentle">
      <Wrapper data-cy={dataCy}>
        <TitleRow>
          {Boolean(icon) && (
            <FnrPageHeaderIcon icon={icon} variant={variant} {...iconProps} />
          )}

          <FnrTypography
            type="header"
            fontSize="28px"
            color="#15436a"
            {...titleProps}
          >
            {title}
          </FnrTypography>
        </TitleRow>
        {subtext && <SubText>{subtext}</SubText>}
      </Wrapper>
    </FnrStaggeredEntry>
  );
}

FnrPageHeader.propTypes = {
  title: string.isRequired,
  icon: string.isRequired,
  subtext: string,
  variant: oneOf(Object.values(headerVariants)),
  iconProps: shape(fnrPageHeaderIconPropTypes),
  dataCy: string,
  titleProps: shape(fnrTypographyPropTypes),
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
`;

const SubText = styled.p`
  font-size: 14px;
  color: #828c8d;
  margin: 4px 0 0;
`;
